import React from 'react'
import {  Accordion } from 'react-bootstrap'
import { furdok } from "../Database";
import Item from "../Item";
import Pageheader from '../partials/Pageheader';

function Furdok() {
	return (
		<>
			<Pageheader>Fürdők</Pageheader>
			<Accordion flush>
				{furdok.map((item, index) =>
					<Item img={item.img} face={item.face} title={item.title} id={index} key={index}>{item.text}</Item>
				)}
			</Accordion>
		</>
	)
}

export default Furdok